import React from 'react'
import Button from 'react-bootstrap/Button'
import BootstrapForm from 'react-bootstrap/Form'

import Icon from './Icon'

export interface ListFilterOption {
  label: string
  value: string
}

export interface ListFilterDefinition {
  key: string
  label: string
  options: ListFilterOption[]
  value: string
}

interface Props {
  filters?: ListFilterDefinition[]
  onFilterChange?: (key: string, value: string) => void
  onReset: () => void
  onSearchChange: (value: string) => void
  resultCount: number
  searchPlaceholder?: string
  searchValue: string
  totalCount: number
}

const ListFilters = ({
  filters = [],
  onFilterChange,
  onReset,
  onSearchChange,
  resultCount,
  searchPlaceholder = 'Cerca...',
  searchValue,
  totalCount,
}: Props) => {
  const hasActiveFilters = Boolean(searchValue.trim()) || filters.some((filter) => filter.value !== 'all')
  const resultLabel = resultCount === 1 ? 'risultato' : 'risultati'

  return (
    <section aria-label="Filtri elenco" className="sq-filter-panel">
      <div className="sq-filter-panel__controls">
        <BootstrapForm.Group className="sq-filter-panel__field sq-filter-panel__search">
          <BootstrapForm.Label>Cerca</BootstrapForm.Label>
          <BootstrapForm.Control
            aria-label="Cerca"
            type="search"
            value={searchValue}
            placeholder={searchPlaceholder}
            onChange={(event: any) => onSearchChange(event.currentTarget.value)}
          />
          <span className="sq-filter-panel__search-icon"><Icon name="search" size={18} /></span>
        </BootstrapForm.Group>

        {filters.map((filter) => (
          <BootstrapForm.Group className="sq-filter-panel__field" key={filter.key}>
            <BootstrapForm.Label>{filter.label}</BootstrapForm.Label>
            <BootstrapForm.Control
              as="select"
              value={filter.value}
              onChange={(event: any) => onFilterChange && onFilterChange(filter.key, event.currentTarget.value)}
            >
              {filter.options.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </BootstrapForm.Control>
          </BootstrapForm.Group>
        ))}

        <Button
          className="sq-filter-panel__reset"
          disabled={!hasActiveFilters}
          variant="outline-secondary"
          onClick={onReset}
        >
          Azzera filtri
        </Button>
      </div>
      <div className="sq-filter-panel__meta" aria-live="polite">
        <span className="sq-filter-panel__count">
          {resultCount} {resultLabel}{resultCount !== totalCount ? ` su ${totalCount}` : ''}
        </span>
      </div>
    </section>
  )
}

export default ListFilters
